var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_capture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24_Specific-player---matches---full-video",
    transform: "translate(-631, -827)",
    fill: "#040802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_capture",
    transform: "translate(631, 827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85714286,12.8571429 L0,12.8571429 L0,20 L7.14285714,20 L7.14285714,17.1428571 L2.85714286,17.1428571 L2.85714286,12.8571429 Z M0,7.14285714 L2.85714286,7.14285714 L2.85714286,2.85714286 L7.14285714,2.85714286 L7.14285714,0 L0,0 L0,7.14285714 Z M17.1428571,17.1428571 L12.8571429,17.1428571 L12.8571429,20 L20,20 L20,12.8571429 L17.1428571,12.8571429 L17.1428571,17.1428571 Z M12.8571429,0 L12.8571429,2.85714286 L17.1428571,2.85714286 L17.1428571,7.14285714 L20,7.14285714 L20,0 L12.8571429,0 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5, 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03846154,1.6 L7.87269231,1.6 C7.80846154,1.6 7.74846154,1.5664 7.71269231,1.5108 L7.02961538,0.4452 C6.85153846,0.1672 6.55115385,0 6.22961538,0 L3.77038462,0 C3.44884615,0 3.14846154,0.1672 2.97038462,0.4452 L2.28730769,1.5108 C2.25153846,1.5664 2.19153846,1.6 2.12730769,1.6 L0.961538462,1.6 C0.706538462,1.6 0.461923077,1.7052 0.281538462,1.8928 C0.101153846,2.0804 0,2.3348 0,2.6 L0,7 C0,7.5524 0.430384615,8 0.961538462,8 L9.03846154,8 C9.56961538,8 10,7.5524 10,7 L10,2.6 C10,2.3348 9.89884615,2.0804 9.71846154,1.8928 C9.53807692,1.7052 9.29346154,1.6 9.03846154,1.6 Z M5,2.4 C3.93846154,2.4 3.07692308,3.296 3.07692308,4.4 C3.07692308,5.504 3.93846154,6.4 5,6.4 C6.06153846,6.4 6.92307692,5.504 6.92307692,4.4 C6.92307692,3.296 6.06153846,2.4 5,2.4 Z M5,3.2 C5.63692308,3.2 6.15384615,3.7376 6.15384615,4.4 C6.15384615,5.0624 5.63692308,5.6 5,5.6 C4.36307692,5.6 3.84615385,5.0624 3.84615385,4.4 C3.84615385,3.7376 4.36307692,3.2 5,3.2 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCapture);
export default __webpack_public_path__ + "static/media/ic_capture.69712f5f6fb8299c64a42f2d1f058839.svg";
export { ForwardRef as ReactComponent };